import "../sass/main.scss";

import Vue from 'vue'
import VModal from 'vue-js-modal'

import "./fontawesome";

import Page from './components/page.vue'
import PageSearch from './components/page-search.vue'
import Person from './components/person.vue'
import PressKit from './components/press-kit.vue'
import SocialShare from './components/social-share.vue'
import ContactForm from './components/contact-form.vue'
import VideoEmbed from './components/video-embed.vue'

// Vue Components
Vue.component(Page.name, Page)
Vue.component(PageSearch.name, PageSearch)
Vue.component(Person.name, Person)
Vue.component(PressKit.name, PressKit)
Vue.component(SocialShare.name, SocialShare)
Vue.component(ContactForm.name, ContactForm)
Vue.component(VideoEmbed.name, VideoEmbed)

// Vue Plugins
Vue.use(VModal, { dynamic: true, injectModalsContainer: true })

// Initialization
let app = new Vue({
	el: '.Page',
})
